import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { UserUrl } from '../../shared/urls/user.url';

@Injectable()
export class HeaderService {
    constructor(public baseService: BaseService) {

    }
    writeAudittrail(id) {
        return this.baseService.postData(UserUrl.WRITE_AUDIT_LOG_OUT + `/${id}`, null);
    }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/components/header/header.service.ts